const initialState = {
  errorMessage: '',
  memberId: null,
  streamTab: 'main',
  api: null,
  designs: [],
  source: 'contentSource',
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_ERROR':
      return {
        ...state,
        errorMessage: action.errorMessage,
      }
    case 'SET_MEMBER_ID':
      return {
        ...state,
        memberId: action.memberId,
      }
    case 'SET_STREAM_TAB':
      return {
        ...state,
        streamTab: action.streamTab,
      }
    case 'SET_API':
      return {
        ...state,
        api: action.api,
      }
    case 'SET_DESIGNS':
      const newDesigns = action.designs.map((item) => ({
        id: item.id,
        key: item.key,
        url: item.url,
        lastModified: item.lastModified,
        size: item.size,
      }))
      return {
        ...state,
        designs: newDesigns,
      }
    case 'DELETE_DESIGN':
      const designs = state.designs.filter(
        (design) => design.key !== action.key
      )
      return {
        ...state,
        designs,
      }
    case 'SET_SOURCE':
      return {
        ...state,
        source: action.source,
      }
    case 'RESET_STATE':
      return state
    default:
      return state
  }
}

export default reducer
